export default "__VITE_ASSET__CZnWtCCN__"